import { faLock } from "@fortawesome/pro-solid-svg-icons/faLock";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Avatar, Grid, Typography } from "@mui/material";
import { AppImageDimension, AppImages } from "app/appImages";
import { MprcContainer, MprcJoinComponents } from "components";
import { ChannelSearchDto } from "generated/CoreApi_v1";
import * as React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router";
import { KnowledgePaths } from "routes/KnowledgeRouter";

/////////////////////////////////////////////////////////////////////////////////////////////////

interface IProps {
    data: ChannelSearchDto;
    onBeforeLinkClick?: () => void;
}

type Props = IProps;

/////////////////////////////////////////////////////////////////////////////////////////////////

export const SearchRenderChannel: React.FC<Props> = (props) => {
    const { t } = useTranslation("shared");
    const { data, onBeforeLinkClick } = props;
    const navUrl = KnowledgePaths.FeedChannel(data.channelId);

    return (
        <MprcContainer>
            <Grid container spacing={2}>
                <Grid>
                    <Avatar
                        variant="rounded"
                        sx={{ width: AppImageDimension.ThumbnailWide.width / 2, height: AppImageDimension.ThumbnailWide.height / 2 }}
                        src={data.thumbnailUrl ?? AppImages.KnowledgeChannelThumbnail}
                    />
                </Grid>
                <Grid size="grow">
                    <Link
                        onClick={onBeforeLinkClick}
                        to={navUrl}
                    >
                        <Typography variant="body1" color="primary.main" noWrap title={data.name}>
                            {data.name}
                        </Typography>
                    </Link>

                    <Typography variant="caption" component="p">
                        {data.isPrivate && <><FontAwesomeIcon icon={faLock} fixedWidth />&nbsp;</>}
                        <MprcJoinComponents
                            separator="&nbsp;&bull;&nbsp;"
                            components={[
                                t("GlobalSearch.SearchRenderChannel.Subscriptions", { count: data.totalSubscriptions }),
                                t("GlobalSearch.SearchRenderChannel.Publications", { count: data.totalPublications })
                            ]}
                        />
                    </Typography>

                    <Typography variant="caption" component="p" noWrap title={data.description ?? undefined}>
                        {data.description}
                    </Typography>
                </Grid>
            </Grid>
        </MprcContainer>
    );
};


export const SearchRenderShortChannel: React.FC<Props> = (props) => {
    const { t } = useTranslation("shared");
    const { data, onBeforeLinkClick } = props;
    const navUrl = KnowledgePaths.FeedChannel(data.channelId);

    return (
        <MprcContainer>
            <Grid container spacing={1}>
                <Grid>
                    <Avatar
                        variant="rounded"
                        sx={{ width: AppImageDimension.ThumbnailWide.width / 3, height: AppImageDimension.ThumbnailWide.height / 3 }}
                        src={data.thumbnailUrl ?? AppImages.KnowledgeChannelThumbnail}
                    />
                </Grid>
                <Grid size="grow">
                    <Link
                        onClick={onBeforeLinkClick}
                        to={navUrl}
                    >
                        <Typography variant="h6" color="primary.main" noWrap title={data.name}>
                            {data.name}
                        </Typography>
                    </Link>

                    <Typography variant="caption">
                        <MprcJoinComponents
                            separator="&nbsp;"
                            components={[
                                data.isPrivate ? <FontAwesomeIcon icon={faLock} fixedWidth /> : null,
                                t("GlobalSearch.SearchRenderChannel.Subscriptions", { count: data.totalSubscriptions }),
                            ]}
                        />
                    </Typography>
                </Grid>
            </Grid>
        </MprcContainer>
    );
};
